import React from 'react';
import { useHistory } from 'react-router-dom';
import { trackCreateUserGeneratedContentCancel } from '../../../models/user-generated-contents/analytics';
import FocusLock from 'react-focus-lock';
import Page, { PageMain, PageSidebar } from '../../../components/ui/page';
import BackButton from '../../../components/ui/back-button';
import useHeaderMinimizer from '../../../common/use-header-minimizer';
import Sidebar from './sidebar';
import UserGeneratedContentForm from './form';
import { useTranslation } from 'react-i18next';
import {
  UserGeneratedContentProvider,
  useUserGeneratedContent,
} from '../../../models/user-generated-contents/context';
import { AudiencesProvider } from '../../../models/audiences';
import UserGeneratedContentFormFields from './fields';
import './../post-creation.scss';

type BackButtonWrapperProps = {
  handleCancelClick: () => void;
};
const BackButtonWrapper = ({ handleCancelClick }: BackButtonWrapperProps) => {
  const { isPersisting, isLoading } = useUserGeneratedContent();
  return (
    <BackButton
      isDisabled={isPersisting || isLoading}
      onClick={handleCancelClick}
    />
  );
};
const UserGeneratedContentEdit = (props: {
  match: { params: { id?: string } };
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  const objectId = props.match.params.id;

  const validId = objectId && objectId !== 'new' ? Number(objectId) : undefined;

  useHeaderMinimizer(true);

  const handleCancelClick = () => {
    history.goBack();
    trackCreateUserGeneratedContentCancel();
  };

  return (
    <UserGeneratedContentProvider id={validId}>
      <AudiencesProvider>
        <FocusLock>
          <div className={'content-submission-overlay-backdrop'} />
          <UserGeneratedContentForm>
            {({ onSave, onSubmit }) => (
              <Page className="ugc-content-submission">
                <BackButtonWrapper handleCancelClick={handleCancelClick} />
                <main
                  className="ugc-content-submission__page_main"
                  aria-label={t('user_generated_content.main_area')}
                >
                  <UserGeneratedContentFormFields />
                </main>
                <aside
                  className="ugc-content-submission__page_sidebar"
                  aria-label={t('user_generated_content.sidebar_area')}
                >
                  <Sidebar onSave={onSave} onSubmit={onSubmit} />
                </aside>
              </Page>
            )}
          </UserGeneratedContentForm>
        </FocusLock>
      </AudiencesProvider>
    </UserGeneratedContentProvider>
  );
};

export default UserGeneratedContentEdit;
